import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { AppFlow } from 'Container/App/interface';

const getFlow = (): AppFlow => window[ADDITIONAL_PAGE_OPTIONS].flow;

export default getFlow;
